import List from './views/List.vue'

export const VacationAccumulationRequestsRoutes = [
  {
    path: '/vacation-accumulation-requests',
    name: 'ListVacationAccumulationRequests',
    component: List,
    meta: {
      auth: true,
      layout: 'home'
      // permission: 'payroll_processed:list'
    }
  }
]
